import { RootState } from '../../store';

export const getStreetSelector = (state: RootState) => state?.streetReducer?.street;
